import { hasValue } from "../../../utils/functions.js";

import TableList from "../../sub-components/Generic/TableList/TableList.vue";
import DateField from "../../common/date-field";

export default {
  name: "ParceiroAtendimento",
  components: {
    TableList,
    DateField
  },
  data() {
    return {
      headers: [
        //{field:'Code',          label:'Código' },
        { field: "Partner.Name", label: "Parceiro", classHeader: 'text-left', classField: 'text-left' },
        { field: "DataCriacao", label: "Data", type: "date" },
        { field: "Descricao", label: "Descrição", classHeader: 'text-left', classField: 'text-left' },
        { field: "Categoria.Nome", label: "Categoria", classHeader: 'text-left', classField: 'text-left' },
        { field: "UserInternal.Name", label: "Usuário" }
      ],
      pageName: 'Atendimento ao Parceiro',
      permissionIsAuthorize: 'ParceiroAtendimento',
      modalTitle: "Nova Descrição",
      countFilter: 0,
      itemList: [],
      lists: {
        UsersInternal: [],
        ParceiroAtendimentoCategoriasFilter: [],
        ParceiroAtendimentoCategoriasForm: [],
        Partners: []
      },
      filter: {
        IdPartner: null,
        NamePartner: null,
        IdentityPartner: null,
        IdUserInternal: null,
        Categoria: null,
        DataCriacaoIni: null,
        DataCriacaoFim: null
      },
      idField: 0,
      formField: {
        Partner: { Id: null },
        DataCriacao: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
        Descricao: null,
        Categoria: { Codigo: null },
        UserInternal: { Id: this.$getUserInternal().Id }
      },
      isSeeing: false,
      loading: false,
      pOpened: null,
      pagination: {
        PageNumber: 1,
        RowsPerPage: 10,
        TotalItems: 0
      },
      validatedFormValidation: false,
      additionalActions: [
        {authorization: 'Add', name: 'Add', label: 'Adicionar Continuação', icon:'fas fa-plus'}
      ]
    };
  },

  mounted() {
    this.loading = true;
    const promises = [
      this.ListarParceiro(),
      this.ListarUsuarioInterno(),
      this.ListarParceiroAtendimentoCategoriaDropDown()
    ];
    Promise.all(promises).then(
      (values) => {
        this.ListarParceiroAtendimento();
      }
    );
  },

  methods: {
    OpenField(item, index, eventName) {
      this.validatedFormValidation = false;
      this.ResetFormField();
      if (eventName == 'Add') {
        // Add new
        this.pOpened = null;
        this.isSeeing = false;
        this.modalTitle = "Nova Anotação";
        this.formField.Partner.Id = item.Partner.Id;
        this.formField.Partner.Name = item.Partner.Id + ' - ' + item.Partner.Name;
        this.$bvModal.show("mFormField");
      } else {
        // View
        this.pOpened = index;
        this.idField = item.Id;
        this.formField.Partner.Id = item.Partner.Id;
        this.formField.Partner.Name = item.Partner.Name;
        this.isSeeing = true;
        this.modalTitle = "Detalhes do Campo";
        this.BuscarParceiroAtendimento();
        this.$bvModal.show("mFormField");
      }
    },

    OpenModalFilter() {
      this.$bvModal.show("mFilter");
    },

    Filter() {
      this.$bvModal.hide("mFilter");
      this.ListarParceiroAtendimento();
    },

    ResetFilter() {
      this.filter = {
        IdPartner: null,
        NamePartner: null,
        IdentityPartner: null,
        IdUserInternal: null,
        CodigoParceiroAtendimentoCategoria: null,
        DataCriacaoIni: null,
        DataCriacaoFim: null
      };
      this.ListarParceiroAtendimento();
    },

    ResetFormField() {
      this.formField = {
        Partner: { Id: null },
        DataCriacao: this.$options.filters.date(new Date(), "YYYY-MM-DD"),
        Descricao: null,
        Categoria: { Codigo: null },
        UserInternal: { Id: this.$getUserInternal().Id }
      };
    },

    SaveField() {
      this.validatedFormValidation = true;
      this.$refs.ParceiroAtendimentoValidationForm.validate().then(isValid => {
        if (isValid) {
          this.loading = true;
          this.isSeeing = true;

          if (this.pOpened == null) {
            // Add
            this.AdicionarParceiroAtendimento();
          }
        }
      });
    },

    BuscarParametrosListarParcerioAtendimento(deletePagination = false) {
      const regExp = new RegExp(/[\D]/g);
      if(this.filter.IdentityPartner != null && regExp.test(this.filter.IdentityPartner)){
        this.$makeToast("Removido characteres que não são digitos.", "warning", "Alterada a Busca de CNPJ");
        this.filter.IdentityPartner = this.filter.IdentityPartner.replace(/[\D]/g, '');
        if(this.filter.IdentityPartner.length == 0){
          this.filter.IdentityPartner = null;
          this.$makeToast("Com os characteres removidos não sobrou nada, CNPJ foi desconsiderado.", 
                          "warning", "CNPJ Desconsiderado");
        }
      }
      let data = {
        ...this.pagination,
        "Object.Partner.Id": this.filter.IdPartner,
        "Object.Partner.Name": this.filter.NamePartner,
        "Object.Partner.Identity": this.filter.IdentityPartner,
        "Object.UserInternal.Id": this.filter.IdUserInternal,
        "Object.Categoria.Codigo": this.filter.CodigoParceiroAtendimentoCategoria,
        "InitialDate": this.filter.DataCriacaoIni,
        "EndDate": this.filter.DataCriacaoFim
      };
      delete data.TotalItems;

      if (deletePagination) {
        delete data.PageNumber;
        delete data.RowsPerPage;
      }
      return data;
    },

    AdicionarParceiroAtendimento() {
      delete this.formField.DataCriacao;
      delete this.formField.Partner.Name;
      this.$store
        .dispatch("AdicionarParceiroAtendimento", this.formField)
        .then(() => {
          this.$makeToast("O campo foi cadastrado com sucesso.", "success", "Campo cadastrado");
          this.$bvModal.hide("mFormField");
          setTimeout(() => {
            this.ListarParceiroAtendimento();
          }, 100);
        })
        .catch(error => {
          this.$makeToast("Tente novamente mais tarde.", "danger", "Erro ao criar campo", error);
        })
        .finally(() => {
          this.loading = false;
          this.isSeeing = false;
        });
    },

    BuscarParceiroAtendimento() {
      if (this.idField != 0) {
        this.loading = true;
        this.$store.dispatch("BuscarParceiroAtendimento", { id: this.idField })
          .then(response => {
            this.formField = response;
          })
          .catch(error => {
            this.$makeToast("Um erro ocorreu ao carregar o campo", "danger", "Erro ao carregar o campo", error);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    ListarParceiroAtendimento() {
      this.loading = true;
      this.countFilter = 0;
      if (hasValue(this.filter.IdMerchant)) this.countFilter++;
      if (hasValue(this.filter.IdUserInternal)) this.countFilter++;
      if (hasValue(this.filter.Categoria)) this.countFilter++;
      if (hasValue(this.filter.CreatedDate)) this.countFilter++;
      const params = this.BuscarParametrosListarParcerioAtendimento();
      this.$store.dispatch("ListarParceiroAtendimento", { params:params })
        .then(response => {
          this.itemList = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao listar os campos. Tente novamente.",
            "danger", "Erro ao listar os Campos", error);
        })
        .finally(() => (this.loading = false));
    },

    GerarRelatorio() {
      this.loading = true;
      const params = this.BuscarParametrosListarParcerioAtendimento(true);
      this.$store.dispatch("RelatorioParceiroAtendimento", { params })
        .then(response => {
          if (hasValue(response.UrlReport)) {
            this.$makeToast("Aguarde a conclusão do download", "info", "Relatório gerado com sucesso");
            window.open(response.UrlReport, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao gerar o relatório", error);
        })
        .finally(() => {
          $("#dropTableOptions").dropdown("hide");
          setTimeout(() => {
            this.loading = false;
          }, 1200);
        });
    },

    ListarUsuarioInterno() {
      return this.$store.dispatch("ListUserInternal", { params: {} })
        .then((response) => {
          this.lists.UsersInternal = response.Objects;
          if(this.lists.UsersInternal.lenght > 1){
            this.lists.UsersInternal.sort((a, b) => a.Name.localeCompare(b.Name));
          }
        })
        .catch((error) => {
          this.$makeToast("Tente atualizar a página", "danger", "Erro ao obter lista de usuários", error);
        });
    },

    ListarParceiroAtendimentoCategoriaDropDown() {
      return this.$store.dispatch("ListarParceiroAtendimentoCategoriaDropDown", { ListaAtivaEExcluida: true })
        .then(response => {
          const PAC = response.Objects;
          if(PAC.length > 1){
            this.lists.ParceiroAtendimentoCategoriasFilter = PAC;
            this.lists.ParceiroAtendimentoCategoriasForm = PAC.filter((categoria) => !categoria.EhExcluido );
          }
        })
        .catch(error => {
          this.$makeToast("Um erro ocorreu ao listar os campos. Tente novamente.",
            "danger", "Erro ao listar os Campos", error);
        });
    },

    ListarParceiro() {
      let params = {
        "Object.IsExcluded": false,
        "Object.IsTest": false,
      };
      return this.$store
        .dispatch("ListPartner", { params: params })
        .then((response) => {
          this.lists.Partners = response.Objects;
          if(this.lists.Partners.lenght > 1){
            this.lists.Partners.sort((a, b) => a.Name.localeCompare(b.Name));
          }
        })
        .catch((error) => {
          this.$makeToast(undefined, "danger", "Erro ao listar os parceiros", error);
        });
    },

    preventDecimal(e) {
      if (e.code == "Comma" || e.code == "Period" || e.code == "Minus") {
        e.preventDefault();
      }
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/pages/ParceiroAtendimento/ParceiroAtendimento.js